<template>
  <div>
    <b-col>
      <Search
        :title="title"
        :allowFields="$lang.indicator_exercise_evidence_fields"
        :url="url"
        :allowCollapse="false"
        :visibleSearch="true"
        :visibleSettings="true"
        :visibleExport="true"
        :visibleFilters="true"
        :visibleViewCount="true"
        :allowEdit="false"
        :filterCatch="true"
        :showTotals="true"
        :openNewTab="true"
        :hasCompetencyCountLink="false"
        addModalSize="xl"
        removeModalSize="lg"
        :defaultViewCount="10"
        :dynamicButtons="dynamicButtons"
        primaryKey="id"
        ref="search"
        @getPermisson="updatePermissions"
        @getRows="getRows"
        @getOther="getOtherData"
        :visibleAdd="isAdmin(permissions, ['admin'])"
      >
        <template slot="addModal" slot-scope="search">
          <LoadingSpinner
            :loading="exerciseLoading"
            :text="$lang.sending_data"
          />
          <b-card v-if="!exerciseLoading">
            <SelectSearch
              :title="$lang.exercise"
              :url="exercise_url"
              v-model="exercises"
              :allowFields="$lang.exercise_fildes"
              :limitOneSelect="false"
              :visibleSearch="true"
            />
            <b-row>
              <b-col class="text-right mt-3">
                <b-button
                  class="mx-1"
                  variant="success"
                  @click="addExercise(search.close)"
                >
                  {{ $lang.submitButton }}
                  <i class="fa fa-check" />
                </b-button>
                <b-button class="mx-1" variant="danger" @click="search.close">
                  {{ $lang.cancelButton }}
                  <i class="fa fa-ban" />
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </template>
      </Search>
      <Confirm
        v-model="deleteConfirm.model"
        :title="$lang.remove_item"
        :description="deleteConfirm.description"
        dynamicClass=""
        :loading="deleteConfirm.loading"
        :preventDefault="true"
        :cancel-title="$lang.no"
        :ok-title="$lang.yes"
        @cancel="deleteConfirm.model = false"
        @ok="removing"
      />
    </b-col>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_edit_evidance"
      size="xl"
      hide-header
      hide-footer
    >
      <AddEditEvidence
        :item="evidance"
        :evidance_exercise_id="evidance_exercise_id"
        :viewMood="viewMood"
        @modal-close="evidanceModal"
        :valueIndicator="indicatorName"
      >
        <template slot="title-bar">
          <span v-html="title" />
        </template>
      </AddEditEvidence>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="clone_indicator_modal"
      size="xl"
      hide-header
      hide-footer
    >
      <b-card>
        <div slot="header">
          <b v-text="$lang.clone_indicator_ecidance" />
        </div>
        <LoadingSpinner
          :loading="isCloneLoading"
          :text="cloneLoadingSpinnerText"
        />
        <b-form @submit.prevent="cloneIndicator" v-if="!isCloneLoading">
          <b-row>
            <b-col cols="12" md="12">
              <b-form-group
                :label="$lang.exercise"
                label-for="exercise"
                :label-cols="this.$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.exercise"
                  :rules="$v.exercise_selected.$params"
                />
                <selectFind
                  :options="exercise_options"
                  v-model="$v.exercise_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.exercise_selected.$dirty
                      ? !$v.exercise_selected.$error
                      : null
                  "
                  :loading="exercise_Loading"
                  @input="getListIndicator"
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.exercise_selected.$error ? 'block' : 'none',
                  }"
                  id="timeing_selected_feedback"
                >
                  {{ $lang.error_required | replace($lang.timeing) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="12">
              <b-form-group
                :label="$lang.indicator"
                label-for="indicator"
                :label-cols="this.$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.indicator"
                  :rules="$v.indicator_selected.$params"
                />
                <selectFind
                  :options="indicator_options"
                  v-model="$v.indicator_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.indicator_selected.$dirty
                      ? !$v.indicator_selected.$error
                      : null
                  "
                  :loading="indicator_Loading"
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.indicator_selected.$error ? 'block' : 'none',
                  }"
                  id="indicator_selected_feedback"
                >
                  {{ $lang.error_required | replace($lang.indicator) }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="12" class="float-right">
              <div slot="footer" class="form-group form-btn">
                <b-button type="submit" size="md" variant="success">
                  <i class="fa fa-check"></i>
                  {{ $lang.submitButton }}
                </b-button>
                <b-button
                  type="reset"
                  class="ml-2"
                  size="md"
                  variant="danger"
                  @click="closeCloneModal"
                >
                  <i class="fa fa-ban"></i>
                  {{ $lang.cancelButton }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-card>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="evidance_sample_modal"
      size="xl"
      hide-header
      hide-footer
    >
      <DragTable
        :title="$lang.sample_evidence"
        :url="exercise_design_evidance_sample_url"
        ref="evidance_sample"
        :dynamicButtons="buttonsIndicators"
        :keyLang="`search_evidance_sample`"
        :hasMoving="false"
        :editRoute="false"
        :removeLabel="$lang.exercise_remove"
        :emptyText="$lang.dataNotExist"
      />
      <b-row>
        <b-col cols="12" md="12" class="float-right">
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="evidance_sample_modal = false"
            >
              <i class="fa fa-ban"></i>
              {{ $lang.close }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import DragTable from "@/components/base/dragTable";
import SelectSearch from "@/components/base/selectSearch";
import Search from "@/components/base/search";
import AddEditEvidence from "./../evidence/add_edit_evidence";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import Confirm from "@/components/base/confirm";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { isAdmin, generateApiUrl, goToRoute } from "@/shared/utils";

export default {
  name: "indicator-evidence",
  validations: {
    exercise_selected: {},
    indicator_selected: {},
  },
  components: {
    SelectSearch,
    AddEditEvidence,
    DragTable,
    Search,
    LoadingSpinner,
    Confirm,
  },
  data() {
    return {
      id: +this.$route.params.id,
      clone_indicator_modal: false,
      viewMood: "",
      evidance: null,
      evidance_exercise_id: null,
      exerciseLoading: false,
      dynamicButtons: [
        {
          id: "0",
          name: "clone",
          text: this.$lang.clone_indicator_ecidance,
          click: this.clone,
        },
        {
          id: "8",
          name: "addIndicator",
          text: this.$lang.authentication_evidence,
          click: this.evidanceChoose,
        },
        {
          id: "3",
          name: "delete",
          click: this.showDeleteConfirm,
        },
      ],
      buttonsIndicators: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "sample_evidence",
          click: this.sample_evidence,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      view_edit_evidance: false,
      exercises: [],
      loading: false,
      exercise: "",
      itemClone: null,
      exercise_selected: null,
      exercise_Loading: false,
      exercise_options: [],
      indicator_selected: null,
      indicator_Loading: false,
      indicator_options: [],
      isCloneLoading: false,
      exercise_design_evidance_sample_url: null,
      evidance_sample_modal: false,
      indicator_id: null,
      permissions: [],
      cloneLoadingSpinnerText: this.$lang.receiving_data,
      deleteConfirm: {
        model: false,
        loading: false,
        description: this.$lang.are_you_sure_to_remove_item,
        itemId: null,
      },
      otherData: null,
    };
  },
  computed: {
    title() {
      const indicatorType = pathOr(
        null,
        ["indicator", "value", "id"],
        this.otherData
      );
      const indicatorName = pathOr(
        "",
        ["indicator", "caption"],
        this.otherData
      );

      return `
        ارتباط تمرین با ${this.$lang.indicator}: 
        <i 
          class="fa-lg fas fa-${
            indicatorType === 1 ? "plus text-success" : "minus text-danger"
          }"></i> ${indicatorName}`;
    },
    indicatorName() {
      return pathOr(null, ["value", "caption"], this.otherData);
    },

    url() {
      return generateApiUrl(["kanoon", "indicator_evidence"], [this.id]);
    },
    exercise_url() {
      return generateApiUrl(["kanoon", "exercise"]);
    },
  },
  methods: {
    pathOr,
    isAdmin,
    generateApiUrl,
    goToRoute,
    sample_evidence(item) {
      const id = pathOr(null, ["id"], item);
      this.exercise_design_evidance_sample_url = generateApiUrl(
        ["kanoon", "exercise_indicator_evidence_sample"],
        [this.indicator_id, this.id, id]
      );
      this.evidance_sample_modal = true;
    },
    async clone(item) {
      this.isCloneLoading = true;
      this.cloneLoadingSpinnerText = this.$lang.receiving_data;
      this.clone_indicator_modal = true;
      this.itemClone = { ...item };
      await this.getListExercise();
      this.isCloneLoading = false;
    },
    clearClone() {
      this.$v.$reset();
      this.exercise_selected = {};
      this.indicator_selected = {};
    },
    closeCloneModal() {
      this.clearClone();
      this.clone_indicator_modal = false;
    },
    async cloneIndicator() {
      try {
        this.isCloneLoading = true;
        this.cloneLoadingSpinnerText = this.$lang.sending_data;
        const indicatorId = +pathOr(null, ["id"], this.itemClone);
        const url = generateApiUrl(
          ["kanoon", "exercise_indicator_evidence_duplicate"],
          [indicatorId, this.id]
        );
        const payload = {
          exercise_id: pathOr(null, ["value"], this.exercise_selected),
          indicator_id: pathOr(null, ["value"], this.indicator_selected),
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.closeCloneModal();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isCloneLoading = false;
      }
    },
    getRows(data) {
      this.exercises = data.map((item) => {
        return { id: item.id };
      });
    },
    async getListExercise() {
      try {
        this.exercise_Loading = true;
        const response = await this.$httpService.get(
          this.$config.api_url + this.$config.kanoon.exercise + `/combo`
        );
        let { data } = response.data;
        this.exercise_options = data.map((x) => {
          return {
            text: x.name,
            value: x.id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.exercise_Loading = false;
      }
    },
    async getListIndicator(item) {
      try {
        this.indicator_Loading = true;
        const response = await this.$httpService.get(
          this.$config.api_url +
            this.$config.kanoon.exercise_indicator.replace("{0}", item.value) +
            `?per_page=200`
        );
        let { result } = response.data.data;
        this.indicator_options = result.map((x) => {
          return {
            text: x.indicator && x.indicator.caption,
            value: x.indicator && x.indicator.id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.indicator_Loading = false;
      }
    },
    async addExercise(callback) {
      try {
        this.exerciseLoading = true;
        const payload = {
          exercise_id: this.exercises.map((c) => c.id),
        };

        const url = generateApiUrl(["kanoon", "indicator_exercise"], [this.id]);
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        callback();
        this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.exerciseLoading = false;
      }
    },
    evidanceModal(val) {
      this.view_edit_evidance = val;
      this.$refs.evidance_search.fetchData();
    },
    evidanceChoose(item) {
      this.evidance_exercise_id = pathOr(null, ["exercise_design_id"], item);
      this.indicator_id = pathOr(null, ["id"], item);

      const id = pathOr(null, ["exercise_design_id"], item);
      const name = "indicator-exercise-evidence";
      const params = { id };
      goToRoute(name, params, {}, false);
    },
    updatePermissions(permissions) {
      this.permissions = [...permissions];
    },
    getItems() {
      this.$refs.search.getItems();
    },
    showDeleteConfirm(item) {
      this.deleteConfirm.model = true;
      this.deleteConfirm.itemId = pathOr(null, ["id"], item);
    },
    async removing() {
      try {
        this.deleteConfirm.loading = true;
        const url = generateApiUrl(
          ["kanoon", "exercise_indicator_id"],
          [this.deleteConfirm.itemId, this.id]
        );
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
        this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.deleteConfirm.loading = false;
        this.deleteConfirm.model = false;
      }
    },
    getOtherData(data) {
      this.otherData = data;
    },
  },
};
</script>
